import Vue from "vue";

import { Component } from "@/decorators";

@Component
export default class ChatBotComponent extends Vue {}
